import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { buildSuggestionTabTitleParams } from './SuggestionTabAlerts/buildSuggestionTabTitleParams';
import { useDocumentTitleStore } from '../store/DocumentTitle/useDocumentTitleStore';
import { useSuggestionTabAlertsStore } from '../store/SuggestionTabAlerts/useSuggestionTabAlertsStore';
import { SUGGESTION_TAB_TITLE_I18N_KEY } from '../utils/constants/suggestionTabAlerts';

export function useDocumentTitleRenderer() {
  const { t } = useTranslation();
  const pageTitle = useDocumentTitleStore((s) => s.pageTitle);
  const unseenCount = useSuggestionTabAlertsStore((s) => s.unseenCount);

  useEffect(() => {
    const appName = t('appName');
    document.title =
      unseenCount > 0
        ? t(
            SUGGESTION_TAB_TITLE_I18N_KEY,
            buildSuggestionTabTitleParams(unseenCount, appName),
          )
        : (pageTitle ?? appName);
  }, [pageTitle, unseenCount, t]);
}
